import { createContext, useContext } from 'react';
import { SupplierInquiry } from '@texas/api/endpoints/inquiryApi';
import { useInquiryDetailContext } from './useInquiryDetailContext';

interface InquiryDetailContextValue {
  inquiry: SupplierInquiry | null;
  loading: boolean;
  error: any;
  isBelowMpq: (quantity: number) => boolean;
  refetch: () => Promise<void>;
}

const InquiryDetailContext = createContext<InquiryDetailContextValue | null>(
  null,
);

export function InquiryDetailProvider({
  inquiryId,
  children,
}: {
  inquiryId: number;
  children: React.ReactNode;
}) {
  const { data, loading, error, refetch } = useInquiryDetailContext(inquiryId);

  const isBelowMpq = (quantity: number) =>
    data?.mpqQuantity != null && quantity < data.mpqQuantity;

  return (
    <InquiryDetailContext.Provider
      value={{ inquiry: data ?? null, loading, error, isBelowMpq, refetch }}
    >
      {children}
    </InquiryDetailContext.Provider>
  );
}

export function useInquiryDetail() {
  const ctx = useContext(InquiryDetailContext);
  if (!ctx)
    throw new Error(
      'useInquiryDetail must be used within InquiryDetailProvider',
    );
  return ctx;
}
